import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { select, Store } from '@ngxs/store';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { imageAssets } from '@app/core/constants/themes';
import { UserSelectors } from '@app/core/states/user/user.selectors';
import { Router } from '@angular/router';
import { diegoRoutes } from '@app/core/enums/orderflow-paths';
import { take } from 'rxjs';
import { ResetUserInfo, SetUserInfo } from '@app/core/states/user/user.actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [MatCard, MatCardTitle, MatButton, IceAlertComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LoginComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private store = inject(Store);

  isAuthenticated = select(UserSelectors.isAuthenticated);

  imageAssets = imageAssets;

  ngOnInit(): void {
    this.authService
      .getUserInfo()
      .pipe(take(1))
      .subscribe(userInfo => {
        if (userInfo && userInfo.isAuthenticated) {
          this.store.dispatch(new SetUserInfo(userInfo));
          this.router.navigate([diegoRoutes.startSale]);
        } else {
          this.store.dispatch(new ResetUserInfo());
        }
      });
  }

  login(): void {
    this.authService.login();
  }

  logout() {
    this.authService.logoff();
  }

  get authErrorMessage(): string {
    return this.authService.authErrorMessage;
  }
}
